import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import * as actions from '../redux/actions'

import text from '../constants/Login'

import { auth, adminPanelUri } from '../services/defaultProps'
import API from '../services/Api'

import '../styles/containers/ResetPassword.css'
import LoginHeader from '../components/LoginHeader'
import FormButton from '../components/FormButton'
import FormInput from '../components/FormInput'
import { toast } from 'react-toastify'
import LoginBackButton from '../components/LoginBackButton'
import useLanguage from '../hooks/useLanguage'
import Popup from '../services/Popup'

const ResetPassword = () => {
  const location = useLocation()
  const history = useHistory()
  const language = useLanguage()

  const authToken = location.search.split('token=').pop().split('&')[0]

  // Divide the token into its parts: header, body and signature
  // eslint-disable-next-line no-unused-vars
  const [header, payload, signature] = authToken.split('.')
  const decodedPayload = JSON.parse(atob(payload))

  const isNewUser = decodedPayload.isNew

  // Detect user device platform
  const userAgent = navigator.userAgent
  const iOS = !!userAgent.match(/iPhone|iPad|iPod/)
  const isAndroid = /android/i.test(userAgent)

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [openPopup, setOpenPopup] = useState(false)

  const storeRedirectionPopup = () => {
    return (
      <Popup
        open={openPopup}
        close={() => {
          setOpenPopup(false)
          if (isNewUser) {
            // Redirect to appropriate Store
            if (iOS) {
              const appStoreURL = 'https://apps.apple.com/us/app/mosty/id6456223705'
              window.location.href = appStoreURL
            }
            if (isAndroid) {
              const playStoreURL = 'https://play.google.com/store/apps/details?id=app.mosty.www.twa'
              window.location.href = playStoreURL
            }
          }
        }}
        closeButton={false}
        textParagraph={`Notamos que você é um novo usuário. Para facilitar a sua experiência, estamos redirecionando você diretamente para a ${
          iOS ? 'App Store' : 'Play Store'
        } para que você possa baixar o aplicativo Mosty no seu dispositivo com total segurança e comodidade.`}
        textButton='Ok'
      />
    )
  }

  const requestPasswordReset = async e => {
    e.preventDefault()

    if (password !== confirmPassword) {
      toast.error(text.invalidPasswordConfirmation[language])
      return setError(text.invalidPasswordConfirmation[language])
    }

    setError(null)
    setLoading(true)

    try {
      const token = await API.resetPassword(authToken, password)
      toast.success(text.successPasswordRecover[language])

      if (isNewUser && (iOS || isAndroid)) {
        setOpenPopup(true)
      } else {
        if ([auth.waitingConsultant, auth.consultant, auth.admin].includes(token.auth)) {
          window.location.replace(adminPanelUri)
        } else {
          history.push('/login')
        }
      }
    } catch (err) {
      console.error('Error on reset password', err)
      if (err.errorMessage) {
        setError(err.errorMessage)
      }
    }

    setLoading(false)
  }

  return (
    <div className='resetpassword-screen-container'>
      {storeRedirectionPopup()}
      <LoginHeader />
      <form className='resetpassword-screen-form'>
        <LoginBackButton onClick={() => history.push('/')} />
        <p className='resetpassword-screen-title'>{text.redefinePassword[language]}</p>
        <p className='resetpassword-screen-subtitle'>{text.redefinePasswordSubtitle[language]}</p>
        <FormInput className='resetpassword-screen-input' placeholder={text.password[language]} value={password}
          onChange={e => setPassword(e.target.value)} type='password' />
        <FormInput className='resetpassword-screen-input' placeholder={text.confirmPassword[language]} type='password'
          value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
        {error !== null && <p className='resetpassword-screen-error'><strong>{error}</strong></p>}
        <FormButton className='resetpassword-screen-button' loading={loading} onClick={requestPasswordReset}>
          {text.redefinePassword[language]}
        </FormButton>
      </form>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(ResetPassword)



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.js